<section class="held-section" data-cy="held-screen">
  <div class="held-info tw-flex tw-items-center tw-mb-[16px]">
    <mat-icon class="tw-text-[18px] tw-mr-[8px]">info_outline</mat-icon>
    <span class="tw-text-[14px]">
      {{ 'ui.funding.held.info' | translate: 'Held withdrawals are listed below.' }}
    </span>
  </div>

  <!-- Skeleton loader for the initial fetch (mirrors the promotions panel). -->
  <div *ngIf="isLoading" class="held-skeleton" data-cy="held-loading">
    <div
      *ngFor="let row of skeletonRows"
      class="held-skeleton__row tw-flex tw-justify-between tw-items-center tw-mb-[10px]"
    >
      <div class="tw-flex tw-items-center">
        <div class="held-skeleton__bar tw-w-[26px] tw-h-[26px] tw-rounded-[4px] tw-mr-[12px]"></div>
        <div>
          <div class="held-skeleton__bar tw-h-[15px] tw-w-[150px] tw-rounded-[4px] tw-mb-[8px]"></div>
          <div class="held-skeleton__bar tw-h-[11px] tw-w-[190px] tw-rounded-[4px] tw-mb-[6px]"></div>
          <div class="held-skeleton__bar tw-h-[11px] tw-w-[130px] tw-rounded-[4px]"></div>
        </div>
      </div>

      <div class="tw-flex tw-flex-col tw-items-end">
        <div class="held-skeleton__bar tw-h-[18px] tw-w-[80px] tw-rounded-[4px] tw-mb-[8px]"></div>
        <div class="held-skeleton__bar tw-h-[20px] tw-w-[90px] tw-rounded-[12px]"></div>
      </div>
    </div>
  </div>

  <!-- Error -->
  <p
    *ngIf="!isLoading && hasError"
    class="held-error tw-text-center tw-text-[15px] tw-mt-[20px]"
    data-cy="held-error"
  >
    {{
      'ui.funding.held.error'
        | translate: 'Unable to load held withdrawals. Please try again later.'
    }}
  </p>

  <ng-container *ngIf="!isLoading && !hasError">
    <!-- Empty -->
    <div
      *ngIf="reviews.length === 0"
      class="held-empty tw-text-center tw-mt-[30px] tw-mb-[30px]"
      data-cy="held-empty"
    >
      <mat-icon class="tw-text-[34px] tw-mb-[8px]">check_circle_outline</mat-icon>
      <span class="tw-block tw-text-[15px]">
        {{ 'ui.funding.held.empty' | translate: 'You have no withdrawals awaiting review.' }}
      </span>
    </div>

    <!-- List -->
    <div *ngIf="reviews.length > 0" class="held-list" data-cy="held-list">
      <div
        *ngFor="let review of reviews; let i = index"
        class="held-item tw-flex tw-justify-between tw-items-center tw-mb-[10px]"
        id="held-item-{{ i }}"
        data-cy="held-item"
      >
        <div class="tw-flex tw-items-center">
          <mat-icon class="held-brand-icon tw-text-[26px] tw-mr-[12px]">{{ brandIcon(review) }}</mat-icon>
          <div class="held-desc">
            <div class="held-card tw-font-bold tw-text-[15px]" data-cy="held-card">
              {{ cardLabel(review) }}
            </div>
            <div class="held-meta tw-text-[12px]">
              <span>{{ 'ui.funding.held.requested' | translate: 'Requested:' }}</span>
              <span data-cy="held-requested">{{ requestedTime(review) }}</span>
            </div>
            <div class="held-meta tw-text-[12px]">
              <span>{{ 'ui.funding.held.reference' | translate: 'Reference:' }}</span>
              <span data-cy="held-reference">{{ review.ReferenceId }}</span>
            </div>
          </div>
        </div>

        <div class="tw-text-right">
          <div class="held-amount tw-font-bold tw-text-[18px]" data-cy="held-amount">
            ${{ review.Amount | number:'1.2-2' }}
          </div>
          <span
            class="held-status {{ statusColor(review) }}"
            [title]="review.StatusDescription || (statusKey(review) | translate: statusLabel(review))"
            data-cy="held-status"
          >
            {{ statusKey(review) | translate: statusLabel(review) }}
          </span>
        </div>
      </div>
    </div>
  </ng-container>
</section>
